<template>
    <modal :adaptive="true" height="auto" name="network_program" @before-open="beforeOpen" style="z-index: 1071">
        <ValidationObserver v-slot="{ invalid }">
            <d-form v-if="networkProgram" id="domainForm" class="card" @submit.prevent="save">
                <d-card-body>
                    <h6 class="card-title">{{networkProgram.program_name}} - event settings</h6>
                    <d-form-row>
                        <d-col md="6" class="form-group">
                            <label>Event name</label>
                            <d-form-select v-model="networkProgram.event_name" @change="changeEvent">
                                <option v-for="eventName in getEventTypes" :value="eventName">
                                    {{ eventName }}
                                </option>
                            </d-form-select>
                        </d-col>
                        <d-col v-if="networkProgram.event_name === 'custom'" md="6" class="form-group">
                            <label>Custom event name</label>
                            <ValidationProvider
                                name="Event name"
                                :rules="'required|alpha_dash|excluded:'+getReservedEventTypes.toString()"
                                v-slot="{ errors }"
                            >
                                <d-input-group>
                                    <d-input class="form-control" :state="errors.length ? 'invalid' : null" v-model="newCustomEvent"/>
                                    <div class="invalid-feedback">{{ errors[0] }}</div>
                                    <d-input-group-addon append v-if="errors.length === 0">
                                        <span class="btn btn-success" @click="addNewCustomEvent()">Save</span>
                                    </d-input-group-addon>
                                </d-input-group>
                            </ValidationProvider>
                        </d-col>
                    </d-form-row>
                    <d-form-row v-if="!getDefaultEventTypes.includes(networkProgram.event_name)">
                        <d-col md="12" class="form-group">
                            <span class="btn btn-secondary" @click="addCustomEventParameter()">
                                Add event parameter
                            </span>
                        </d-col>
                        <template v-for="(parameter, index) in networkProgram.event_params">
                            <d-col md="5" class="form-group">
                                <label v-if="index === 0">Parameter name</label>
                                <ValidationProvider
                                    name="Name"
                                    :rules="'required|alpha_dash|excluded:'+getReservedParameterNames.toString()+'|not_starts_with:'+getReservedParameterPrefixes.toString()"
                                    v-slot="{ errors }"
                                >
                                    <d-input class="form-control" :state="errors.length ? 'invalid' : null" v-model="networkProgram.event_params[index].key"/>
                                    <div class="invalid-feedback">{{ errors[0] }}</div>
                                </ValidationProvider>
                            </d-col>
                            <d-col md="5" class="form-group">
                                <label v-if="index === 0">Parameter value</label>
                                <ValidationProvider name="Value" :rules="'required'" v-slot="{ errors }">
                                    <d-input class="form-control" :state="errors.length ? 'invalid' : null" v-model="networkProgram.event_params[index].value"/>
                                    <div class="invalid-feedback">{{ errors[0] }}</div>
                                </ValidationProvider>
                            </d-col>
                            <d-col md="2" class="form-group">
                                <label v-if="index === 0">Action</label>
                                <span class="btn btn-danger" @click="networkProgram.event_params.splice(index, 1)">Remove</span>
                            </d-col>
                        </template>
                    </d-form-row>
                    <d-form-row v-if="networkProgram.event_name === 'sign_up'">
                        <template v-for="(parameter, index) in networkProgram.event_params">
                            <d-col md="5" class="form-group">
                                <label>Parameter name</label>
                                <input class="form-control" type="text" disabled="disabled"
                                       v-model="networkProgram.event_params[index].key"/>
                            </d-col>
                            <d-col md="5" class="form-group">
                                <label>Parameter value</label>
                                <input class="form-control" type="text"
                                       v-model="networkProgram.event_params[index].value"/>
                            </d-col>
                        </template>
                    </d-form-row>
                    <d-form-row v-if="networkProgram.event_name === 'generate_lead'">
                        <template v-for="(parameter, index) in networkProgram.event_params">
                            <d-col md="5" class="form-group">
                                <label v-if="index === 0">Parameter name</label>
                                <input class="form-control" type="text" disabled="disabled"
                                       v-model="networkProgram.event_params[index].key"/>
                            </d-col>
                            <d-col md="5" class="form-group">
                                <label v-if="index === 0">Parameter value</label>
                                <d-form-select v-if="parameter.key === 'currency'"
                                               v-model="networkProgram.event_params[index].value">
                                    <option v-for="currency in ['EUR', 'USD']" :value="currency">
                                        {{ currency }}
                                    </option>
                                </d-form-select>
                                <input v-else-if="parameter.key === 'value'" class="form-control" type="number"
                                       step=".1" min="0" v-model="networkProgram.event_params[index].value"/>
                                <input v-else class="form-control" type="text"
                                       v-model="networkProgram.event_params[index].value"/>
                            </d-col>
                        </template>
                    </d-form-row>
                </d-card-body>
                <d-card-footer class="d-flex justify-content-end">
                    <span @click="hideModal()" class="btn btn-secondary">Close</span>
                    <input value="Save" type="submit" :disabled="invalid" class="btn btn-success ml-1">
                </d-card-footer>
            </d-form>
        </ValidationObserver>
    </modal>
</template>

<script>
  export default {
    data() {
      return {
        networkProgram: null,
        newCustomEvent: null
      };
    },
    methods: {
      hideModal() {
        this.$modal.hide('network_program');
      },

      changeEvent(newEvent) {
        this.newCustomEvent = null
        if (newEvent === 'sign_up') {
          this.networkProgram.event_params = [{key: 'method', value: ''}]
        } else if (newEvent === 'generate_lead') {
          this.networkProgram.event_params = [
            {key: 'currency', value: 'EUR'},
            {key: 'value', value: '0'},
            {key: 'lead_source', value: ''},
          ]
        } else {
          this.networkProgram.event_params = []
        }
      },

      addNewCustomEvent() {
        this.networkProgram.event_name = this.newCustomEvent
        this.networkProgram.event_params = []
        this.$store.commit('gaEventTypesStore/addEventType', this.newCustomEvent)
      },

      addCustomEventParameter() {
        this.networkProgram.event_params.push({key: '', value: ''})
      },

      save() {
        this.$emit('programEventUpdated', this.networkProgram);
        this.hideModal()
      },

      beforeOpen(event) {
        this.networkProgram = event.params.networkProgram
        this.networkProgram['event_name'] = event.params.networkProgram.event_name || 'purchase'
      }
    },
    computed: {
      getEventTypes() {
        return this.$store.getters['gaEventTypesStore/getEventTypes']
      },
      getDefaultEventTypes() {
        return this.$store.getters['gaEventTypesStore/getDefaultEventTypes']
      },
      getReservedEventTypes() {
        return this.$store.getters['gaEventTypesStore/getReservedEventTypes']
      },
      getReservedParameterNames() {
        return this.$store.getters['gaEventTypesStore/getReservedParameterNames']
      },
      getReservedParameterPrefixes() {
        return this.$store.getters['gaEventTypesStore/getReservedParameterPrefixes']
      },
    }
  };
</script>
